import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { DaveSharedComponentsModule } from './../../../../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { DaveLoadingModule } from './../../../../dave-loading/dave-loading.module';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { AppButtonModule } from "../../../../dave-utils-module/app-button-module/app-button.module";
import { NewVacationComponent } from "./new-vacation.component";
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { SmallFileCardModule } from '../../../../small-file-card/small-file-card.module';


@NgModule({
    declarations: [
        NewVacationComponent,
    ],
    imports: [
        CommonModule,
        MatCardModule,
        AppButtonModule,
        MatTooltipModule,
        ReactiveFormsModule,
        MatInputModule,
        FontAwesomeModule,
        DaveLoadingModule,
        DaveSharedComponentsModule,
        MatDialogModule,
        MatCheckboxModule,
        MatFormFieldModule,
        DropzoneModule,
        SmallFileCardModule,
    ],
})
export class NewVacationModule {
}
